import { skipToken } from "@reduxjs/toolkit/query";
import { ExchangeName } from "@shared/types";
import { watchlistService } from "app/services/watchlist.service";
import { displayResultMessage } from "utils/misc";

const useWatchlist = (skip?: boolean) => {
  let { data: watchlist, isLoading: getWatchlistLoading } =
    watchlistService.useGetWatchlistQuery(skip ? skipToken : undefined);

  const [removeFromWatchlist, { isLoading: removeFromWatchlistLoading }] =
    watchlistService.useRemoveFromWatchlistMutation();

  const getIsSymbolInWatchlist = (symbol?: string) =>
    watchlist?.watchlist?.some((market) => market.symbol === symbol) || false;

  const removeMarket = (
    symbol: string,
    exchange: ExchangeName,
    onSubmit: () => void
  ) => {
    displayResultMessage(removeFromWatchlist({ symbol, exchange }).unwrap())
      .then(() => onSubmit())
      .catch(() => {});
  };

  return {
    watchlist,
    getWatchlistLoading,
    removeMarket,
    removeFromWatchlistLoading,
    getIsSymbolInWatchlist,
  };
};

export default useWatchlist;
